import { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Boundary caught:", error, info);
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-ink text-white px-6">
          <div className="text-center max-w-md">
            <p className="label-mono mb-4">Agency HQ</p>
            <p className="font-display text-2xl font-bold mb-3">Something went wrong.</p>
            <p className="text-slate-400 text-sm">Please refresh the page. The issue has been noted.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
